class SequencerNode extends Weaver.Node

  @className = 'Sequencer'

  constructor: (id) ->
    super(id)

  create: (name = "New Sequencer", noteSequence = '["A#1", "G#2", "C#2", "E2"]') =>
    type = await Weaver.Node.firstOrCreate('Sequencer')
    @set('name', name)
    @set('noteSequence', noteSequence)
    @relation('type').add(type)
    @save()

export default SequencerNode
